// import { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import CategoryPage from './pages/CategoryPage';
import ProductDetailPage from './pages/ProductDetailPage';
import ContactPage from './pages/ContactPage';
import './App.css';

function App() {

//   const [message, setMessage] = useState("");

//   useEffect(() => {
//   fetch("http://localhost:5000:5000/api") // Explicitly mention the backend address
//     .then((response) => response.json())
//     .then((data) => setMessage(data.message))
//     .catch((error) => console.error("Error fetching API:", error));
// }, []);
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/category/:categoryId" element={<CategoryPage />} />
          <Route path="/category/:categoryId/product/:productId" element={<ProductDetailPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
